"use client";

import React from "react";
import GenericLazyLoader from "@/components/common/generic-lazy-loader";
import { SpotlightType } from "@/types/dto/destinations-page/destination-page-types";

interface Props {
  spotlightData: SpotlightType;
}


const LazyLoadSpotlightSection = ({ spotlightData }: Props) => 
    <GenericLazyLoader
      importComponent={() => import("./spotlight-section")}
      componentProps={{ spotlightData }}
      debugName="Spotlight Section"
      threshold={0.1}
      rootMargin="200px 0px"
    />;


export default LazyLoadSpotlightSection;